import { render } from "./IncomeTab.vue?vue&type=template&id=10b9e1dd"
import script from "./IncomeTab.vue?vue&type=script&lang=js"
export * from "./IncomeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__